<template>
  <v-container fluid class="webConArticlePage-management mt-4 px-1">
    <v-row>

      <template>
        <v-row justify="center">
          <v-dialog
              v-model="dialog_upload"
              width="1250px"
          >
            <v-card>

              <UploadManagement
                  id="Conpage_UploadManagement">

              </UploadManagement>

            </v-card>


          </v-dialog>
        </v-row>
      </template>


      <v-col cols="12">
        <v-card class="mb-1" v-if="state=='index'">


          <v-card-title class="pa-5 pb-3">
            <p>การจัดการเนื้อหาคลังความรู้/บทความ</p><span
              class="grey--text font-weight-regular subtitle-2 pt-1">{{ '\xa0 (' + webConArticlePages.length }} รายการ) </span>
            <v-spacer></v-spacer>
            <div>
              <v-text-field
                  v-model="search"
                  append-icon="mdi-magnify"
                  label="ค้นหา (Search)"
                  single-line
                  hide-details
                  class="search"
              ></v-text-field>
            </div>
          </v-card-title>

          <v-card-text class="px-5">
            <v-data-table
                :loading="isReceiving || isDeleting"
                loading-text="Loading... Please wait"
                class="product-table"
                show-select
                :headers="headers"
                :items-per-page="15"
                :footer-props="{
                'items-per-page-options': [5, 10, 15, 50,-1]
                }"
                :items="webConArticlePages"
                :search="search"
                sort-by="article_pages_id">
              <template v-slot:top>


                <template>
                  <v-btn
                      color="success"
                      dark
                      class="my-4 button-shadow"
                      @click="addItem()"
                  >เพิ่มรายการใหม่
                  </v-btn>
                </template>


              </template>


              <template v-slot:item.switch_lang="{ item }">
                <v-btn
                    fab
                    x-small
                    depressed
                    color=""
                >TH
                </v-btn>
                <v-btn v-if="item.switch_lang=='Y'"
                       fab
                       x-small
                       depressed
                       color=""
                >EN
                </v-btn>

              </template>


              <template v-slot:item.active="{ item }">
                <span v-if="item.active == 'Y'" class="v-chip theme--light v-size--small success"><span
                    class="v-chip__content">ใช้งาน</span></span>
                <span v-else class="v-chip theme--light v-size--small "><span
                    class="v-chip__content">ยกเลิก</span></span>

              </template>


              <template v-slot:item.api="{ item }">
                <v-btn
                    class="mr-3 button-shadow"
                    @click="editItem(item)"
                    small
                    color="success"
                >แก้ไข
                </v-btn>
                <v-btn
                    @click="deleteItem(item)"
                    small
                    class="button-shadow"
                    color="secondary"
                >ลบข้อมูล
                </v-btn>
              </template>
            </v-data-table>
          </v-card-text>


        </v-card>

        <v-card class="mb-1" v-if="state=='editForm' || state=='addForm'">

          <v-card-title class="pa-5 pb-3">
            <p>{{ formTitle }}</p>

          </v-card-title>


          <v-card-text class="pa-5 pt-0">
            <v-form
                ref="form"
                v-model="editForm.valid"
                lazy-validation>

              <v-row align="center">

                <v-col class="d-flex" cols="12" sm="4" v-if="state=='editForm'">
                  <v-text-field
                      v-model="editForm.article_page_url"
                      :counter="60"
                      :rules="editForm.textReqRules.concat(editForm.URLRules).concat([v => v && v.length >= 10 || 'ต้องมีตัวอักษรอย่างน้อย 10 ตัว'])"
                      label="URL(ID) เนื้อหาบทความ"
                      required
                      disabled
                  ></v-text-field>
                </v-col>



                <v-col class="d-flex" cols="12" sm="4" v-else>
                  <v-text-field
                      v-model="editForm.article_page_url"
                      :counter="60"

                      :rules="editForm.textReqRules.concat(editForm.URLRules).concat([v => v && v.length >= 10 || 'ต้องมีตัวอักษรอย่างน้อย 10 ตัว'])"
                      label="URL(ID) รหัสเนื้อหาบทความ"
                      required
                  ></v-text-field>
                </v-col>

                <v-row align="center">
                  <v-col class="d-flex" cols="12" sm="4">

                    <v-select
                        @change="changeDocGroup('e')"
                        v-model="editForm.article_page_group_tag"
                        :rules="editForm.textReqRules"
                        :items="article_page_group_combo"
                        item-text="parameter_th"
                        item-value="parameter_value"
                        label="ประเภทเอกสาร"
                        required
                        clearable=""
                    ></v-select>


                  </v-col>

                  <v-col class="d-flex" cols="12" sm="4">

                    <v-select
                        v-model="editForm.article_page_type_tag"
                        :rules="editForm.multipleReqRules"
                        :items="article_page_type_combo"
                        attach
                        chips
                        deletable-chips
                        item-text="parameter_th"
                        item-value="parameter_value"
                        label="ส่วนแสดงผล"
                        multiple
                        required
                    ></v-select>


                  </v-col>

                  <v-col class="d-flex" cols="12" sm="4">

                    <v-switch
                        v-model="editForm.switch_lang"
                        inset
                        true-value="Y"
                        false-value="N"
                        :rules="editForm.textReqRules"
                        label="เพิ่มเนื้อหาภาษา [EN]"
                        required
                    ></v-switch>


                  </v-col>

                </v-row>

              </v-row>


              <v-row align="center">

                <v-col class="d-flex" cols="12" sm="12">
                  <v-text-field
                      v-model="editForm.article_page_title_th"
                      :rules="editForm.textReqRules"
                      label="ชื่อบทความ (TH)"
                      required
                  ></v-text-field>
                </v-col>

                <v-col class="d-flex" cols="12" sm="12" v-if="editForm.switch_lang=='Y'">
                  <v-text-field
                      v-model="editForm.article_page_title_en"
                      :rules="editForm.textReqRules"
                      label="ชื่อบทความ (EN)"
                      required
                  ></v-text-field>
                </v-col>

              </v-row>


              <v-row align="center">

                <v-col>

                  <v-chip

                      color="success"
                      class="ma-2"
                  >
                    เนื้อหาบทความ (TH)
                  </v-chip>
                  <v-chip
                      @click="showUploads"
                      color="info"
                      class="ma-2"
                  >
                    <v-icon left>
                      mdi-cloud-upload
                    </v-icon>

                    อัพโหลดไฟล์/รูป ประกอบเนื้อหา
                  </v-chip>

                  <editor
                      id="article_page_content_th"
                      v-model="editForm.article_page_content_th"
                      :api-key=tiny.api
                      :init="{
                       convert_urls:true,
                       relative_urls:false,
                       remove_script_host:false,
                       // images_upload_url: baseURLApi+'/uploads_tinymce',
                       height: 500,
                       menubar: true,
                       plugins: tiny.plugins,
                       toolbar: tiny.toolbar,
                       valid_elements : '*[*]', //tag css other
                       forced_root_block : false //remove tag p
                      }"
                              />


                </v-col>


              </v-row>

              <v-row align="center" v-if="editForm.switch_lang=='Y'">

                <v-col>

                  <v-chip

                      color="secondary"
                      class="ma-2"
                  >
                    เนื้อหาบทความ (EN)
                  </v-chip>

                  <v-chip
                      @click="showUploads"
                      color="info"
                      class="ma-2"
                  >
                    <v-icon left>
                      mdi-cloud-upload
                    </v-icon>

                    อัพโหลดไฟล์/รูป ประกอบเนื้อหา
                  </v-chip>

                  <editor
                      id="article_page_content_en"
                      v-model="editForm.article_page_content_en"
                      :api-key=tiny.api
                      :init="{
                       convert_urls:true,
                       relative_urls:false,
                       remove_script_host:false,
                       height: 500,
                       menubar: true,
                       plugins: tiny.plugins,
                       toolbar: tiny.toolbar,
                       valid_elements : '*[*]', //tag css other
                       forced_root_block : false //remove tag p
                      }"
                  />
                </v-col>

              </v-row>


              <v-row align="center">


                <v-col class="d-flex" cols="12" sm="4">

                  <v-switch
                      v-model="editForm.active"
                      inset
                      color="success"
                      true-value="Y"
                      false-value="N"
                      :rules="editForm.textReqRules"
                      label="ใช้งาน"
                      required
                  ></v-switch>

                </v-col>

              </v-row>

              <v-row align="center">

                <v-col class="d-flex" cols="12" sm="12">
                  <v-row justify="end">
                    <v-btn
                        color="secondary"
                        outlined
                        class="button-shadow mr-4"
                        @click="cancelForm">
                      ยกเลิก
                    </v-btn>
                    <v-btn
                        color="primary"
                        outlined
                        class="button-shadow mr-4"
                        @click="reset"
                        v-if="state=='addForm'">
                      ล้างข้อมูล
                    </v-btn>
                    <v-btn
                        :disabled="!editForm.valid"
                        color="primary"
                        class="button-shadow mr-4"
                        @click="validate">
                      บันทึก
                    </v-btn>
                  </v-row>

                </v-col>

              </v-row>

            </v-form>
          </v-card-text>


        </v-card>
      </v-col>
    </v-row>

    <v-snackbar
        v-model="snackbar"
        :color="color"
        right
        top
        style="top: 50px">
      <div v-html="text" class=""></div>
      <template v-slot:action="{ attrs }">
        <v-btn
            dark
            text
            v-bind="attrs"
            @click="snackbar = false">
          ปิด
        </v-btn>
      </template>
    </v-snackbar>

  </v-container>
</template>

<script>
import config from "@/config";
import {mapActions, mapState} from 'vuex';
import validateRules from '@/use/validateRules.js';
import Editor from '@tinymce/tinymce-vue';
import UploadManagement from '@/pages/WebContent/UploadManagement/UploadManagement';
import axios from "axios";

export default {
  name: 'ConArticlePageManagement',
  data() {
    return {
      state: 'index',
      tiny: config.tiny,
      baseURLApi: config.baseURLApi,
      snackbar: null,
      dialog_upload: false,
      search: '',
      search_data: {
        article_page_group_tag: "",
        article_page_type_tag: "",
      },
      selected: [],
      headers: [
        {
          text: 'URL(ID)',
          align: 'start',
          value: 'article_page_url',
        },
        {text: 'หลายภาษา', value: 'switch_lang'},
        {text: 'ชื่อ(TH)', value: 'article_page_title_th'},
        {text: 'ชื่อ(EN)', value: 'article_page_title_en'},
        {text: 'ใช้งาน', value: 'active'},
        {text: 'การจัดการ', value: 'api', sortable: false},
      ],

      notification: '<p class="font-weight-bold mb-0">หน้าเว็บพร้อมแล้วสำหรับการทำงาน - This page is ready',
      editedIndex: -1,
      editForm: {
        valid: true,
        page_url: '',
        URLRules: validateRules.URLRules,
        textReqRules: validateRules.textReqRules,
        page_title_th: '',
        page_title_en: '',
        page_content_th: '',
        page_content_en: '',
        article_page_group_tag: '',
        article_page_type_tag: '',
        switch_lang: 'N',
        active: 'N',
      },
      article_page_group_combo: [],
      article_page_type_combo: [],
      detail_combo: [],
    }
  },
  components: {
    'editor': Editor, // <- Important part
    UploadManagement
  },
  computed: {
    // map state ใน Store ของเราเข้ามาเป็น Computed * เข้ามาเป็นตัวแปร
    // Method จะเรียก Function ทุกครั้งที่ Component re-render ใหม่ ซึ่งต่างจาก Computed จะไม่เรียก Function เมื่อ ข้อมูลไม่เปลี่ยน
    ...mapState('web_con_article_pages', ['webConArticlePages', "isReceiving", "isDeleting", "idToDelete", "webConArticlePageMessage", "isUpdating", "errorMessage"]),
    formTitle() {
      return this.editedIndex === -1 ? 'เพิ่มรายการใหม่' : 'แก้ไขรายการ'
    },
  },
  watch: {
    //Watched Property  คือ เฝ้าดูว่าข้อมูลในตัวแปลที่เรากําหนดมีการเปลี่ยนแปลงหรือไม่ ถ้ามีการเปลี่ยนแปลงก็จะรันคําสั่งที่เราเขียนไว้

    webConArticlePageMessage() {

      if (this.webConArticlePageMessage !== '') {
        this.notification = this.webConArticlePageMessage

        if (this.errorMessage == true) {
          this.addErrorNotification();
        } else {
          this.addSuccessNotification();
        }
        this.close();
      }
    }
  },
  created() {
    this.addSuccessNotification();
  },
  mounted() {

    //ดึงฟังก์ชั่น จาก store
    this.getWebConArticlePagesRequest(this.search_data);
    this.getDcParamCombobox();
    this.resetValue();

  },
  methods: {
    // mapAction() เป็น function สําหรับ map action ใน Store ของเราเข้ามาเป็น Methods
    ...mapActions('web_con_article_pages',
        [
          "getWebConArticlePagesRequest",
          "deleteWebConArticlePageRequest",
          "updateWebConArticlePageRequest",
          "createWebConArticlePageRequest"
        ]
    ),
    resetValue() {

      this.editForm = {
        valid: true,
        textReqRules: validateRules.textReqRules,
        multipleReqRules: validateRules.multipleReqRules,
        article_pages_id: null,
        article_page_type_tag: '',
        article_page_group_tag: '',
        article_page_title_th: '',
        article_page_title_en: '',
        article_page_content_th: '',
        article_page_content_en: '',
        switch_lang: 'N',
        active: 'N',
      }
    },
    async getDcParamCombobox() {


      try {

        await axios.post(config.baseURLApi + '/combo_dc_param/' + 'WEB' + '/' + 'ARTICLE_PAGE_GROUP', '', {
          headers: {},
        }).then(res => {
          this.article_page_group_combo = res.data;

          this.detail_combo = [];

          axios.post(config.baseURLApi + '/combo_dc_param_like/' + 'WEB' + '/' + 'ARTICLE_PAGE_TYPE_UNIT_', '', {
            headers: {},
          }).then(res2 => {

            if (res2.data.length > 0) {

              var objRes = (res2.data).reduce(function (r, a) {  //map key group
                r[a.parameter_name] = r[a.parameter_name] || [];
                r[a.parameter_name].push(a);
                return r;
              }, Object.create(null));

              for (var i in objRes) { // object to array key value
                // alert(i); // alerts key
                // alert(objRes[i]); //alerts key's value
                this.detail_combo.push({
                  v_key: i.replace("ARTICLE_PAGE_TYPE_UNIT_", ""),
                  v_value: objRes[i],
                })
              }

            }

          });


        });


      } catch (e) {
        this.showSnackbar(e);
      }


    },
    async addItem() {

      var content ="<section class=\"about-top\"><div class=\"container\"><div class=\"space-110\"/>\n" +
          "กรอกรายละเอียดที่นี่.....\n" +
          "<div class=\"space-130\"/>\n" +
          "<div class=\"space-70\"/>\n" +
          "</div></section>";
      this.editedIndex = -1 //index = -1 add
      this.resetValue();
      this.editForm.article_page_url = null;
      this.editForm.article_page_title_th = null;
      this.editForm.article_page_title_en = null;
      this.editForm.article_page_content_th = content;
      this.editForm.article_page_content_en = content;
      this.editForm.switch_lang = 'N';
      this.editForm.active = 'Y';
      // this.editForm.article_page_group_tag = null;
      this.editForm.article_page_type_tag = null;
      this.editForm.article_page_group_tag = 'A1';
      await this.changeDocGroup('e');
      this.state = 'addForm';

    },
    async editItem(item) {

      this.resetValue();
      this.editedIndex = this.webConArticlePages.indexOf(item) //index ของ row ที่จะแก้ไข
      this.editForm.article_pages_id = item.article_pages_id;
      this.editForm.article_page_url = item.article_page_url;
      this.editForm.article_page_group_tag = item.article_page_group_tag;
      await this.changeDocGroup('e');
      this.editForm.article_page_type_tag = !item.article_page_type_tag != true ? item.article_page_type_tag.split(",") : '';

      this.editForm.article_page_title_th = item.article_page_title_th;
      this.editForm.article_page_title_en = item.article_page_title_en;
      this.editForm.article_page_content_th = item.article_page_content_th;
      this.editForm.article_page_content_en = item.article_page_content_en;
      this.editForm.switch_lang = item.switch_lang;
      this.editForm.active = item.active;



      // this.editForm = Object.assign({}, item) //ถ้าใช้ validate not work!!
      this.state = 'editForm';

    },
    deleteItem(item) {

      confirm('ต้องการลบรายการนี้หรือไม่?') && this.deleteWebConArticlePageRequest({article_pages_id: item.article_pages_id})


    },
    close() {

      if (this.errorMessage == false || this.webConArticlePageMessage == '') {
        this.state = "index";
        this.editedIndex = -1
      }
    },
    save() {

      if (this.editedIndex > -1) { //> -1 is แก้ไขรายการ else เพิ่มรายการใหม่
        !config.isBackend ?
            Object.assign(this.webConArticlePages[this.editedIndex], this.editForm)
            :
            this.updateWebConArticlePageRequest(this.editForm)
      } else {
        !config.isBackend ?
            this.webConArticlePages.push(this.editForm)
            :
            this.createWebConArticlePageRequest(this.editForm)
      }


    },

    changeDocGroup(v_form) {
      var article_page_group_tag = null;
      article_page_group_tag = v_form == 'e' ? this.editForm.article_page_group_tag : this.search_data.article_page_group_tag;
      console.log(this.editForm)
      if (!article_page_group_tag == false) { //flase is not nall
        this.editForm.article_page_type_tag = null
        try {
          this.article_page_type_combo = this.detail_combo.find(item => item.v_key === article_page_group_tag).v_value
        } catch (e) {
          console.log(e)
          this.article_page_type_combo = []
        }

      } else {
        this.editForm.article_page_type_tag = null
        this.article_page_type_combo = []
      }
    },
    addSuccessNotification() {
      this.snackbar = true;
      this.color = config.light.success;
      this.text = this.notification;

    },
    addErrorNotification() {
      this.snackbar = true;
      this.color = config.light.secondary;
      this.text = this.notification;
    },


    validate() {
      if (this.$refs.form.validate()) this.save()
    },

    reset() {
      this.$refs.form.reset()
    },

    cancelForm() {
      this.$refs.form.reset()
      // this.close()
      this.state = "index";
      this.editedIndex = -1
    },
    showUploads() {
      this.dialog_upload = true;
    },
    searchData() {
      this.getWebConArticlePagesRequest(this.search_data);
    },
    async beforeMount() {
    },

  },
}
</script>

<style src="./ConArticlePageManagement.scss" lang="scss"/>
